export default __webpack_public_path__ + "static/media/5.43f8a318.png";